import { Checkbox } from '@nextui-org/react'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RouteConstant } from '../../routes/RouteConstant'
import { IconEye, IconEyeOff } from '@tabler/icons-react'
import { useForm } from 'react-hook-form'
import { generateValidationSchema } from '../../utils/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import authQueries from '../../queries/authQueries'
import { useDispatch } from 'react-redux'
import { setLogin } from '../../redux/reducers/authReducers'
import { setActiveTab } from '../../redux/reducers/settingsReducers'
import { snackbarToast } from '../../components/SnackbarToast'

const Login = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [showPassword, setShowPassword] = useState(false)

    const inputFields = [
        {
            name: "email",
            label: "Email",
            placeholder: "Email",
            required: true,
            type: "email"
        },
        {
            name: "password",
            label: "Password",
            placeholder: "Password",
            required: true,
            type: showPassword ? "text" : "password"
        }
    ]

    const { handleSubmit, register, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(generateValidationSchema(inputFields))
    })

    const login = authQueries.useLoginMutation(
        (res) => {
            if(res?.success){
                if(res?.data?.dept_id === 1 || res?.data?.dept_id === 8){
                    const data = {
                        token: res?.token,
                        ...res?.data
                    }
                    dispatch(setLogin(data))
                    dispatch(setActiveTab(RouteConstant.USERS))
                    navigate(RouteConstant.USERS)
                }else{
                    snackbarToast('Only management can login', 'error')
                    return
                }
            }
            if(!res?.success){
                snackbarToast(res?.message, 'error')
            }
        }
    )

    const onSubmit = (data) => {
        login.mutateAsync(data)
    }


  return (
    <div className="relative bg-gradient-to-r from-primary to-primary min-h-[100vh] flex items-center justify-center">
        <div className="absolute h-full w-full bg-cover bg-center bg-[url('https://react.spruko.com/vexel-ts/preview/assets/1-U0r4Y3EP.png')] z-0"></div>
        <div className="absolute h-full w-full bg-primary opacity-75 z-10"></div>
        <div className="relative z-20 flex items-center justify-center w-full p-2">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='bg-white p-8 rounded-xl w-[400px] text-black text-[12px]'>
                    <div className='text-center'>
                        <div className='text-2xl font-semibold'>Sign In</div>
                        <div>Sign in to your account to continue.</div>
                    </div>
                    <div className='mt-6'>
                        {
                            inputFields?.map((item, index)=>(
                                <div key={index} className='mt-2'>
                                    <label className="font-medium">{item?.label}</label>
                                    <div className='relative'>
                                        <input
                                        {...register(item.name)}
                                        type={item?.type}
                                        name={item.name}
                                        placeholder={item?.placeholder}
                                        className="border h-[35px] border-[#e9edf6] pl-4 rounded-sm font-regular pr-3 w-full"
                                        />
                                        {
                                            item?.name === 'password' &&
                                            <button onClick={()=>setShowPassword(!showPassword)} type='button' className='absolute right-3 top-2'>
                                                {
                                                    showPassword ? <IconEyeOff strokeWidth={1.5} color="#a9ada6" size={20} /> : <IconEye strokeWidth={1.5} color="#a9ada6" size={20} />
                                                }
                                            </button>
                                        }
                                    </div>
                                    <div className='text-[red] italic text-[11px]'>{errors[item?.name]?.message}</div>
                                </div>
                            ))
                        }
                    </div>
                    <div className='flex justify-between mt-3'>
                        <div className='font-semibold text-black'>
                            <Checkbox type="checkbox" size='xs'>
                                <div className='text-[12px] font-medium'>Remember me</div>
                            </Checkbox>
                        </div>
                        <div className='font-medium text-primary'>Forgot Password?</div>
                    </div>
                    <div>
                        <button disabled={login.isLoading} className='bg-primary text-white py-2 px-6 rounded-lg font-semibold w-full mt-3'>
                            {
                                login.isLoading ? "Loading..." : "Sign In"
                            }
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
  )
}

export default Login